module.exports = "<ng-multiselect-dropdown\r\n  [settings]=\"dropdownSettings\"\r\n  [data]=\"dropdownList\"\r\n  [placeholder]=\"placeHolder\"\r\n  [(ngModel)]=\"selectedItems\"\r\n  (ngModelChange)=\"emitByType()\"\r\n  *ngIf=\"isLoad && showMultiselect\">\r\n</ng-multiselect-dropdown>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/multi-select-dropdown/subdivision-multi-select/subdivision-multi-select.component.html
// module id = 2346
// module chunks = 66